<template>
  <section>
    <gs-header title="Quản lý tỉnh thành">
      <router-link :to="{ name: 'create-city' }" class="ui mini blue button"><i class="fa fa-plus"></i> Thêm
        mới</router-link>
    </gs-header>
    <div class="padding-sm-all">
      <gs-table :ref="cityTable" :table-name="cityTable" data-source="cities" :data-params="filters"
        :data-sorted="sorted" :data-sorts="sorts" @remove-filter="removeFilter">
        <section slot="filters">
          <el-row>
            <el-col :span="6">
              <el-select v-model="filters.region_id" filterable placeholder="Chọn vùng miền" @change="filter"
                class="width-100">
                <el-option label="Chọn vùng miền" :value="-1">
                </el-option>
                <el-option v-for="region in regions" :key="region.id" :label="region.name" :value="region.id">
                </el-option>
              </el-select>
            </el-col>
          </el-row>
        </section>
        <template slot-scope="datas">
          <el-table :data="datas.data" border :row-class-name="tableRowClassName" style="width: 100%">
            >
            <el-table-column label="#" width="80">
              <template slot-scope="scope">
                <small v-if="dataPaginations[cityTable]">{{ (scope.$index + 1) +
                  ((dataPaginations[cityTable].current_page - 1) * dataPaginations[cityTable].per_page) }}</small>
              </template>
            </el-table-column>

            <!-- <el-table-column
              label="Tỉnh thành"
              width="100"
            >
              <template slot-scope="scope">
                <p><span class="shipment-code-display">{{scope.row.id}}</span></p>
              </template>
            </el-table-column> -->

            <el-table-column label="Vùng Miền" width="100">
              <template slot-scope="scope">
                <p><span>{{ scope.row.region_name }}</span></p>
              </template>
            </el-table-column>

            <el-table-column label="Tên">
              <template slot-scope="scope">
                <p class="text-center">{{ scope.row.name }} ({{ scope.row.short_name }})</p>
              </template>
            </el-table-column>

            <el-table-column label="Mã Bưu Chính">
              <template slot-scope="scope">
                <p class="text-center"><span class="shipment-code-display">{{ scope.row.code }}</span></p>
              </template>
            </el-table-column>
            <el-table-column v-for="(carrier, index) in listCarriers" :label="carrier.name" :key="index">
              <template slot-scope="scope">
                <p class="text-center"><span class="shipment-code-display text-normal-case">{{ scope.row[carrier.key]
                    }}</span></p>
              </template>
            </el-table-column>

            <el-table-column label="Lấy hàng">
              <template slot-scope="scope">
                <i class="fa fa-check-square-o" v-if="scope.row.allow"></i><i v-else class="fa fa-square-o"></i>
              </template>
            </el-table-column>

            <el-table-column width="95">
              <template slot-scope="scope">
                <section class="padding-sm-top padding-sm-bottom">
                  <el-tooltip placement="top" content="Chi tiết" class="display-inline" v-if="!scope.row.deleted_at">
                    <a class="text-blue padding-all display-inline-block cursor-pointer"
                      @click.prevent="detailCity(scope.row)"><i class="fa fa-search"></i></a>
                  </el-tooltip>
                  <el-tooltip placement="top" content="Sửa" class="display-inline" v-if="!scope.row.deleted_at">
                    <router-link class="text-orange padding-all display-inline-block"
                      :to="{ name: 'edit-city', params: { id: scope.row.id } }"><i class="fa fa-pencil-square-o"
                        aria-hidden="true"></i></router-link>
                  </el-tooltip>
                  <el-tooltip placement="top" content="Xóa" class="display-inline" v-if="!scope.row.deleted_at">
                    <a @click.prevent="deleteCity(scope.row)"
                      class="text-red padding-all display-inline-block cursor-pointer"><i class="fa fa-trash"></i></a>
                  </el-tooltip>
                  <el-tooltip placement="top" content="Khôi phục" class="display-inline" v-if="scope.row.deleted_at">
                    <a class="text-blue padding-all display-inline-block cursor-pointer" @click="restore(scope.row)"><i
                        class="fa fa-refresh" aria-hidden="true"></i></a>
                  </el-tooltip>
                </section>
              </template>
            </el-table-column>
          </el-table>
        </template>
      </gs-table>
      <el-dialog :title="'Chi tiết tỉnh thành: ' + this.city.name" :visible.sync="detailModal">
        <el-row>
          <el-col :span="24">
            <p class="margin-sm-top margin-sm-bottom">Vùng miền: <span class="text-blue text-bold">{{ city.name
                }}</span>
            </p>
            <p class="margin-sm-top margin-sm-bottom">Code: <span class="shipment-code-display">{{ city.code }}</span>
            </p>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <p class="margin-sm-top margin-sm-bottom">Mã giao hàng nhanh: <span class="shipment-code-display">{{
              city.code_ghn
                }}</span></p>
          </el-col>
          <el-col :span="12">
            <p class="margin-sm-top margin-sm-bottom">Mã VTP: <span class="shipment-code-display">{{ city.code_vtp
                }}</span>
            </p>
          </el-col>
          <el-col :span="12">
            <p class="margin-sm-top margin-sm-bottom">Mã Ninja Van: <span class="shipment-code-display">{{ city.code_njv
                }}</span></p>
          </el-col>
          <el-col :span="12">
            <p class="margin-sm-top margin-sm-bottom">Mã Kerry: <span class="shipment-code-display">{{ city.code_kerry
                }}</span>
            </p>
          </el-col>
        </el-row>
        <el-table v-if="city.regions" :data="city.regions.data">
          <el-table-column type="index" width="50">
          </el-table-column>
          <el-table-column property="name" label="Tên">
          </el-table-column>
        </el-table>
      </el-dialog>
    </div>
  </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { debounce, keys, forEach } from 'lodash'
import ls from 'local-storage'
import { deleteCity, restoreCity } from 'src/api/city'
import { listCarriers } from 'src/stubs/carriers'
export default {
  name: 'City',
  data() {
    return {
      cityTable: 'cities',
      filters: {
        region_id: -1,
        sort: 'created_at:-1'
      },
      sorted: {
        created_at: -1
      },
      sorts: [
        { key: 'created_at', name: 'Ngày tạo' }
      ],
      detailModal: false,
      listCarriers: listCarriers
    }
  },
  computed: {
    ...mapGetters('region', ['regions']),
    ...mapGetters('city', ['city'])
  },
  methods: {
    ...mapActions('region', ['getAllRegion']),
    ...mapActions('city', ['getCity', 'setCity']),
    filter: debounce(function () {
      let lsFilter = ls.get('filters', {})
      if (!lsFilter) {
        lsFilter = {}
      }
      lsFilter[this.cityTable] = this.filters
      ls.set('filters', lsFilter)
      if (ls.get('doFilter')) {
        this.reloadGsTable(this.cityTable)
      }
    }, 300),
    removeFilter() {
      if (!this.checkDefaultFilter({
        region_id: -1,
        sort: 'created_at:-1'
      })) {
        this.reloadGsTable(this.cityTable)
      }
      this.filters = {
        region_id: -1,
        sort: 'created_at:-1'
      }
    },
    checkDefaultFilter(filters) {
      let diff = false
      let lkeys = keys(filters)
      forEach(lkeys, key => {
        if (filters[key] !== this.filters[key]) {
          this.diff = true
        }
      })
      return diff
    },
    deleteCity(city) {
      this.setCity(city)
      this.$confirm(`Bạn chắc chắn muốn xóa tỉnh thành ${this.city.name}`, 'Xóa tỉnh thành', {
        confirmButtonText: 'Xóa',
        cancelButtonText: 'Không',
        type: 'warning'
      }).then(() => {
        this.delCity()
      }).catch(() => {

      })
    },
    delCity() {
      deleteCity(this.city.id).then(response => {
        if (response.code === 200) {
          this.$message({
            type: 'success',
            message: 'Xóa tỉnh thành thành công'
          })
          this.reloadGsTable(this.cityTable)
        } else {
          this.$message({
            type: 'danger',
            message: 'Xóa tỉnh thành thất bại'
          })
        }
      })
    },
    detailCity(city) {
      this.detailModal = true
      this.getCity({ id: city.id, params: { include: 'regions' } })
    },
    tableRowClassName(row) {
      if (row.deleted_at) {
        return 'row-orange'
      }
      return null
    },
    restore(city) {
      this.setCity(city)
      this.$confirm(`Bạn chắc chắn muốn khôi phục tỉnh thành ${this.city.name}`, 'Khôi phục tỉnh thành', {
        confirmButtonText: 'Khôi phục',
        cancelButtonText: 'Không',
        type: 'warning'
      }).then(() => {
        this.resCity()
      }).catch(() => {

      })
    },
    resCity() {
      restoreCity(this.city.id).then(response => {
        if (response.code === 200) {
          this.$message({
            type: 'success',
            message: 'Khôi phục tỉnh thành thành công'
          })
          this.reloadGsTable(this.cityTable)
        } else {
          this.$message({
            type: 'error',
            message: 'Khôi phục tỉnh thành thất bại'
          })
        }
      })
    }
  },
  mounted() {
    if (ls.get('filters') && ls.get('filters')[this.cityTable]) {
      this.filters = ls.get('filters')[this.cityTable]
      setTimeout(() => {
        ls.set('doFilter', true)
      }, 100)
    }
    if (!this.regions.length) {
      this.getAllRegion({ params: { limit: -1 } })
    }
    this.listenReloadGsTable()
    this.sorted = this.getSorted(this.cityTable)
  },
  beforeRouteEnter(to, from, next) {
    if (from.fullPath === '/') {
      ls.remove('filters')
      ls.set('doFilter', true)
    } else {
      if (ls.get('filters') && ls.get('filters')['cities']) {
        ls.set('doFilter', false)
      } else {
        ls.set('doFilter', true)
      }
    }
    next()
  }
}
</script>

<style lang="css" scoped></style>



// WEBPACK FOOTER //
// City.vue?1e330468